import React from 'react';

import Icon from 'components/acommon/Icon';
import StyledIcon from 'components/acommon/StyledIcon';

import {HeaderWrapper, SectionContainer, Title} from './styled';

type HeaderProps = Omit<SectionProps, 'expanded'> & {
  isExpanded?: boolean;
  isExpandable?: boolean;
  toggleExpanded?: React.Dispatch<React.SetStateAction<boolean>>;
};
function Header({isExpanded, isExpandable, title, icon, toggleExpanded}: HeaderProps) {
  const handleArrowClick = () =>
    toggleExpanded ? toggleExpanded(!isExpanded) : () => {};

  return (
    <HeaderWrapper onClick={handleArrowClick}>
      {icon && <StyledIcon name="payment" color="#6B6B95" />}
      <Title>{title}</Title>
      {isExpandable && <Icon name="arrow-bottom" size="10" />}
    </HeaderWrapper>
  );
}

type SectionProps = {
  expanded?: boolean;
  title: string;
  icon?: any;
  children?: React.ReactNode | JSX.Element | null;
};
function Section({expanded, children, ...props}: SectionProps) {
  const isExpandable = expanded !== undefined;
  const [isExpanded, toggleExpanded] = React.useState(expanded !== false);

  const expandControls = isExpandable ? {toggleExpanded, isExpandable, isExpanded} : {};

  return (
    <SectionContainer>
      <Header {...expandControls} {...props} />
      {isExpanded && children}
    </SectionContainer>
  );
}
export default Section;
